const createButtonGroup = (pageData, buttonGroup) => {
  if (!buttonGroup) return []
  if (!pageData) return buttonGroup
  if (!pageData.eventBaseUrls) return buttonGroup

  const embellishedButtonGroup = buttonGroup?.map((button) => {
    if (button.type !== 'eventLayout') return button
    return {
      ...button,
      baseUrl: button.eventId
        ? `${pageData.eventBaseUrls.event}`
        : `${pageData.eventBaseUrls.eventUmbrella}`
    }
  })
  return embellishedButtonGroup
}

export default createButtonGroup
